import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'title-dark-highlight' }>

function TitleDarkHighlight(block: BlockProps): ReactElement {
  const { text, options } = block
  const backgroundColor = options?.backgroundColor
  const centerText = options?.centerText

  return (
    <Container>
      <Grid>
        <div
          className={cn(`col-span-full text-left py-4 md:py-2 lg:py-3`, {
            'bg-black p-4 md:px-2.5 lg:px-4': backgroundColor === 'black',
            'bg-telesoft p-4 md:px-2.5 lg:px-4': backgroundColor === 'blue',
          })}
        >
          <Text
            variant="mediumHeading"
            className={cn({
              'text-white': backgroundColor === 'black',
              'text-black': backgroundColor === 'blue',

              'text-center': centerText === true,
            })}
          >
            {text}
          </Text>
        </div>
      </Grid>
    </Container>
  )
}

export default TitleDarkHighlight
